import { render, staticRenderFns } from "./baseFormPageDialog.vue?vue&type=template&id=53d48a9e&scoped=true&"
import script from "./baseFormPageDialog.vue?vue&type=script&lang=js&"
export * from "./baseFormPageDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseFormPageDialog.vue?vue&type=style&index=0&id=53d48a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d48a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d48a9e')) {
      api.createRecord('53d48a9e', component.options)
    } else {
      api.reload('53d48a9e', component.options)
    }
    module.hot.accept("./baseFormPageDialog.vue?vue&type=template&id=53d48a9e&scoped=true&", function () {
      api.rerender('53d48a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/baseFormPageDialog.vue"
export default component.exports